import MenuSimple from "../ui/menuSimple";
import CardGrid from "../features/cardGrid";
import luke from '../../images/lukeSkywalker.jpg'
import yoda from '../../images/yoda.jpg'
import kylo from '../../images/kylo.jpg'
import plagueis from '../../images/plagueis.jpg'
import Footer from "../ui/footer";

const Personajes = () => {
    const info = [

        {
            sectionName: "personajes",
            id: 0,
            image: luke,
            text: "un granjero de tatooine que descubre su conexión con la fuerza y se convierte en la nueva esperanza de la galaxia. guiado por antiguos maestros, luke aprende que el verdadero poder no está solo en el combate, sino en la compasión y la fe en la luz.",
            side: "light",
            title: "luke skywalker"
        },
        {
            sectionName: "personajes",
            id: 1,
            image: yoda,
            text: "el más sabio de los jedi, pequeño en tamaño pero inmenso en conocimiento. yoda entrenó generaciones enteras, enseñando que la fuerza fluye a través del equilibrio, la paciencia y la conexión con todo lo que vive.",
            side: "light",
            title: "yoda"
        },
        {
            sectionName: "personajes",
            id: 2,
            image: kylo,
            text: "nacido como ben solo, fue seducido por el lado oscuro y renació como kylo ren. dividido entre la luz y la sombra, su camino está marcado por la ira, la duda y la búsqueda de un poder que logre silenciar su conflicto interno.",
            side: "dark",
            title: "kylo ren"
        },
        {
            sectionName: "personajes",
            id: 3,
            image: plagueis,
            text: "un lord sith legendario obsesionado con vencer a la muerte. darth plagueis exploró los secretos más profundos del lado oscuro, capaz de manipular la vida misma, pero irónicamente incapaz de salvarse de su propio aprendiz.",
            side: "dark",
            title: "darth plagueis the wise"
        }

    ];

    return(
        <>
            <MenuSimple />
            <CardGrid info={info} />
            <Footer />
        </>
    )
}

export default Personajes;